import BaseService from "../BaseService";

class SystemService extends BaseService {

  static NAME = 'SystemService';

}

export default SystemService;
